import api from 'api/axiosInstance';
import { getReviewYears } from 'components/pages/YearlyReview/helpers';
import type { YearlyReviewData } from 'types/global.types';

const getYearlyReviewWrapped = (): Promise<YearlyReviewData> =>
  api.get(`/v2/metrics/wrapped/${getReviewYears().year}`);

export default getYearlyReviewWrapped;
